import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value != null && value !== "" ? aed(value) : "";
}

async function buildHtml(title, report, metaHtml, tableHtml) {
  const company = await resolveReportLetterhead({ branchId: report?.branch_id, allBranches: report?.all_branches });
  return buildReportDocument({
    title,
    company,
    metaHtml,
    bodyHtml: tableHtml,
  });
}

export async function printAgeWiseReport(report, title) {
  if (!report) return false;
  const rows = (report.rows || [])
    .map(
      (r) => `
      <tr>
        <td>${r.party_code || ""}</td>
        <td>${r.party_name}</td>
        <td class="num">${cell(r.total_outstanding)}</td>
        <td class="num">${cell(r.current)}</td>
        <td class="num">${cell(r.days_31_60)}</td>
        <td class="num">${cell(r.days_61_90)}</td>
        <td class="num">${cell(r.days_90_plus)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildHtml(
    title,
    report,
    `<div><strong>As of:</strong> ${escapeReportHtml(report.as_of_date)}</div>`,
    `<table>
      <thead><tr><th>Code</th><th>Party</th><th>Total</th><th>0-30</th><th>31-60</th><th>61-90</th><th>90+</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>`,
  );
  return openReportPrint(html);
}

export async function printPartyLedgerReport(report) {
  if (!report) return false;
  const title = report.party_type === "customer" ? "Customer Ledger" : "Supplier Ledger";
  const rows = (report.entries || [])
    .map(
      (e) => `
      <tr>
        <td>${e.date || ""}</td>
        <td class="mono">${e.reference || ""}</td>
        <td>${e.type}</td>
        <td class="num">${cell(e.debit)}</td>
        <td class="num">${cell(e.credit)}</td>
        <td class="num">${cell(e.balance)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildHtml(
    title,
    report,
    `<div><strong>Party:</strong> ${escapeReportHtml(report.party?.code)} — ${escapeReportHtml(report.party?.name)}</div>
     ${periodMeta(report)}`,
    `<table>
      <thead><tr><th>Date</th><th>Ref</th><th>Type</th><th>Debit</th><th>Credit</th><th>Balance</th></tr></thead>
      <tbody>
        <tr><td colspan="3"><em>Opening balance</em></td><td></td><td></td><td class="num">${cell(report.opening_balance)}</td></tr>
        ${rows}
      </tbody>
    </table>`,
  );
  return openReportPrint(html);
}

export async function printFinancialReport(report, type, options = {}) {
  const withBranch = report ? { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches } : report;
  switch (type) {
    case "customer-age":
      return printAgeWiseReport(withBranch, "Customer Age Wise Outstanding");
    case "supplier-age":
      return printAgeWiseReport(withBranch, "Supplier Age Wise Outstanding");
    case "customer-ledger":
    case "supplier-ledger":
      return printPartyLedgerReport(withBranch);
    default:
      return false;
  }
}
